import { render, staticRenderFns } from "./ColaboradoresPontosAdminPage.vue?vue&type=template&id=23bea141&scoped=true"
import script from "./ColaboradoresPontosAdminPage.vue?vue&type=script&lang=js"
export * from "./ColaboradoresPontosAdminPage.vue?vue&type=script&lang=js"
import style0 from "./ColaboradoresPontosAdminPage.vue?vue&type=style&index=0&id=23bea141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bea141",
  null
  
)

export default component.exports